import { Link } from "react-router-dom";
import { COMPANY, NAV_LINKS } from "@/lib/site";
import { MapPin, Phone, Mail, Clock, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-ink text-white relative noise" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img
                src={COMPANY.logo}
                alt="Infokarta logo"
                className="w-12 h-12 rounded-full object-cover ring-1 ring-white/20 bg-white"
              />
              <div className="leading-tight">
                <div className="font-brand text-xl font-bold tracking-tight text-white uppercase">{COMPANY.short}</div>
                <div className="overline text-[10px] text-white/60 -mt-0.5">d.o.o. · Split</div>
              </div>
            </div>
            <div className="overline text-white/60">Legalizacija nekretnina · RH</div>
            <h2 className="font-display text-4xl sm:text-5xl tracking-tighter mt-4 leading-[0.95]">
              Spremni za<br />
              <span className="text-white/60">legalizaciju?</span>
            </h2>
            <p className="text-white/70 mt-6 max-w-md leading-relaxed">
              Pošaljite osnovne podatke o objektu — javljamo se u roku od 24 sata s
              jasnom procjenom postupka, cijene i rokova.
            </p>
            <Link
              to="/prijava"
              data-testid="footer-cta"
              className="inline-flex items-center gap-2 mt-8 bg-white text-ink px-6 py-3 text-sm font-medium rounded-sm hover:bg-white/90 transition-colors"
            >
              Otvori prijavu
              <ArrowUpRight className="w-4 h-4" strokeWidth={1.75} />
            </Link>
          </div>

          <div className="md:col-span-3">
            <div className="overline text-white/50">Navigacija</div>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-white/85 hover:text-white text-[15px] transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/prijava" className="text-white/85 hover:text-white text-[15px] transition-colors">
                  Forma za prijavu
                </Link>
              </li>
              <li>
                <Link to="/legalizacija-kuca" className="text-white/85 hover:text-white text-[15px] transition-colors">
                  Legalizacija kuće
                </Link>
              </li>
              <li>
                <Link to="/legalizacija-dalmacija" className="text-white/85 hover:text-white text-[15px] transition-colors">
                  Legalizacija Dalmacija
                </Link>
              </li>
              <li>
                <Link to="/cijena-legalizacije" className="text-white/85 hover:text-white text-[15px] transition-colors">
                  Cijena legalizacije
                </Link>
              </li>
              <li>
                <Link to="/dokumentacija-za-legalizaciju" className="text-white/85 hover:text-white text-[15px] transition-colors">
                  Dokumentacija za legalizaciju
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline text-white/50">Kontakt</div>
            <ul className="mt-5 space-y-4 text-[15px]">
              <li className="flex items-start gap-3 text-white/85">
                <MapPin className="w-4 h-4 mt-1 text-white/60" strokeWidth={1.5} />
                <span>{COMPANY.address}</span>
              </li>
              <li className="flex items-start gap-3 text-white/85">
                <Phone className="w-4 h-4 mt-1 text-white/60" strokeWidth={1.5} />
                <a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`} className="hover:text-white">
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/85">
                <Mail className="w-4 h-4 mt-1 text-white/60" strokeWidth={1.5} />
                <a href={`mailto:${COMPANY.email}`} className="hover:text-white">
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/85">
                <Clock className="w-4 h-4 mt-1 text-white/60" strokeWidth={1.5} />
                <span>{COMPANY.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/50">
          <div>© {new Date().getFullYear()} {COMPANY.name}. Sva prava pridržana.</div>
          <div className="flex items-center gap-6">
            <span>OIB: {COMPANY.oib}</span>
            <Link to="/admin" className="hover:text-white/80" data-testid="footer-admin-link">
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
